import React from 'react'
import { getDatePickerPeriods as getPeriods, DEFAULT_PERIODS } from '@wf/datetime'
import { DatePickerPeriod } from '../period'

/**
 * Get a list of DatePickerPeriod given their period keys.
 * Uses the default-periods of @wf/datetime of non are provided.
 *
 * @example <caption>Basic usage with @wf/datetime constants</caption>
 * <code>
 * const predefinedPeriods = getDatePickerPeriods([
 *     PERIOD_NEXT_2_YEARS,
 *     PERIOD_NEXT_YEAR,
 *     PERIOD_NEXT_6_MONTH,
 *     PERIOD_NEXT_3_MONTH,
 *     PERIOD_NEXT_MONTH
 * ], intl)
 *
 * <DatePicker {...{ predefinedPeriods }} />
 * </code>
 *
 * @param {Array} [periods=[]] - Array containing the required periods, e.g. PERIOD_NEXT_MONTH
 * @param {Intl} intl - Global modux intl helper
 * @return {Array<DatePickerPeriod>} The corresponding date picker period elements
 */
export function getDatePickerPeriods(intl, periods = DEFAULT_PERIODS) {
    return renderDatePickerPeriods(getPeriods(periods, intl))
}

/**
 * Get a list of DatePickerPeriod given their period objects.
 *
 * @param {Array} [periods=[]] - Array containing the required period objects
 * @return {Array<DatePickerPeriod>} The corresponding date picker period elements
 */
export function renderDatePickerPeriods(periods = []) {
    return periods.map(({ interval: value, key, title }, index) => {
        const parsedKey = String(key || index).toLocaleLowerCase()
        return <DatePickerPeriod {...{ className: `t3sel-datepicker-${parsedKey}`, title, value }} key={key || title} />
    })
}
